import Portfolio from './components/Portfolio';
import './styles/styles.css';

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;